import { useAuth0 } from "@auth0/auth0-react";
import React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import StarRating from "../components/StarRating";
import { useCartContext } from "../context/cart_context";

const Course = (props) => {
  const {
    id,
    image,
    course_name,
    creator,
    actual_price,
    discounted_price,
    rating_count,
    rating_star,
    category,
  } = props;
  const { addToCart } = useCartContext();
  const { user, isAuthenticated, isLoading } = useAuth0();
  return (
    <CourseCard>
      <div className="item-img">
        <img src={image} alt={course_name} />
      </div>
      <div className="item-body">
        <h5 className="item-name">{course_name}</h5>
        <span className="item-creator">{creator}</span>
        <div className="item-rating flex">
          <span className="rating-star-val">{rating_star}</span>
          <StarRating rating_star={rating_star} />
          <span className="rating-count">({rating_count})</span>
        </div>
        <div className="item-price">
          <span className="item-price-new">R{discounted_price}</span>
          <span className="item-price-old">R{actual_price}</span>
        </div>
      </div>
      {isAuthenticated && user && user["email"].includes("student") && (
        <div className="item-btns flex">
          <Link to={`/video/${id}`} className="item-btn see-details-btn">
            See details
          </Link>
          <Link
            to="/cart"
            className="item-btn add-to-cart-btn"
            onClick={() =>
              addToCart(
                id,
                image,
                course_name,
                creator,
                discounted_price,
                category
              )
            }
          >
            Add to cart
          </Link>
        </div>
      )}
    </CourseCard>
  );
};

const CourseCard = styled.div`
  margin-bottom: 20px;
  border: 1px solid rgba(0, 0, 0, 0.1);
  box-shadow: rgba(149, 157, 165, 0.1) 0px 8px 24px;
  display: flex;
  flex-direction: column;
  .item-body {
    margin: 14px 0;
    padding: 4px 18px;

    .item-name {
      font-size: 15px;
      line-height: 1.4;
      font-weight: 800;
    }
    .item-creator {
      font-size: 12px;
      font-weight: 500;
      color: rgba(0, 0, 0, 0.6);
    }
    .rating-star-val {
      margin-bottom: 5px;
      font-size: 14px;
      font-weight: 800;
      color: #b4690e;
      margin-right: 6px;
    }
    .rating-count {
      font-size: 12.5px;
      margin-left: 3px;
      font-weight: 500;
      opacity: 0.8;
    }
    .item-price-new {
      font-weight: 700;
      font-size: 15px;
    }
    .item-price-old {
      font-weight: 500;
      text-decoration: line-through;
      font-size: 15px;
      margin-left: 8px;
      opacity: 0.8;
    }
  }
  .item-btns {
    justify-self: flex-start;
    padding: 4px 8px 30px 18px;
    margin-top: auto;
    .item-btn {
      font-size: 15px;
      display: inline-block;
      padding: 6px 16px;
      font-weight: 700;
      transition: var(--transition);
      white-space: nowrap;

      &.see-details-btn {
        background: transparent;
        border: 1px solid var(--clr-black);
        margin-right: 5px;

        &:hover {
          background: rgba(0, 0, 0, 0.9);
          color: var(--clr-white);
        }
      }
      &.add-to-cart-btn {
        color: var(--clr-white);
        background: rgba(0, 0, 0, 0.9);
        border: 1px solid rgba(0, 0, 0, 0.9);

        &:hover {
          background: transparent;
          color: rgba(0, 0, 0, 0.9);
        }
      }
    }
  }
`;
export default Course;
